import { inviteTicket } from '@/services/APIService'
import store from '../store/index'

function stripHTML (moustacheString) {
  return moustacheString.replace(/<[^>]*>/gm, '')
}

function templateMailText (mailText, student, user, code, ticketbaseUrl) {
  const templateMailText = mailText
    .replace(/<i class=[\\]?"q-icon material-icons cursor-pointer[\\]?" onclick=[\\]?"this.parentNode.parentNode.removeChild\(this.parentNode\)[\\]?">close<\/i>/gm, '')
    .replace(/<p><span class=[\\]?"moustache bg-primary[\\]?"( contenteditable="false")?>link<\/span>/gm, ticketbaseUrl)
    .replace(/(\s|&nbsp;)*<span class=[\\]?"moustache bg-primary[\\]?"( contenteditable="false")?>link<\/span>/gm, ' ' + ticketbaseUrl)
    .replace(/<span class=[\\]?"moustache bg-primary[\\]?"( contenteditable="false")?>.*?.<\/span>/gm, (value) => {
    const strippedValue = stripHTML(value).trim()

    switch (strippedValue) {
      case 'voornaam leerling':
        return student.firstname || ''
      case 'achternaam leerling':
        return (student.middlename ? student.middlename + ' ' : '') + (student.lastname ? student.lastname + ' ' : '')
      case 'link' :
        return ticketbaseUrl
      case 'code' :
        return code
      case 'naam ib-er' :
        return student.gd_ibnaam
    }
    return strippedValue
  })

  if (templateMailText.includes('class="moustache bg-primary"')) {
    // Register error
    this.$toasty.error(this.$t('mail_service.mail_parse_error.error'))
    this.$store.dispatch('parantion/error/registerError', {
      message: 'Mail parsing error, class="moustache bg-primary" found',
      errorTrace: 'templateMailText in MailService.ts',
    })
    return ''
  }
  return templateMailText
}

// what is this for ?
// const keywords = ['voornaam leerling', 'achternaam leerling', 'link', 'naam ib-er', 'code']

export default {
  async sendTicketMail (ticketHash, recipient, code, write, student, user, linkMail, codeMail) {
    const environment = store.state.parantion.environment !== 'live' ? store.state.parantion.environment + '.' : ''

    const ticketbaseUrl = `https://${store.state.parantion.user.database}.${environment}parantion.nl/?ticket=${ticketHash}`

    code = '' + code

    const templatedMailText = templateMailText(linkMail.body, student, user, code, ticketbaseUrl)
    const templatedMailTitle = stripHTML(templateMailText(linkMail.title, student, user, code, ticketbaseUrl))
    const templatedCodeMailText = templateMailText(codeMail.body, student, user, code, ticketbaseUrl)
    const templatedCodeMailTitle = stripHTML(templateMailText(codeMail.title, student, user, code, ticketbaseUrl))

    const mail = {
      subject: templatedMailTitle || `Uitnodiging voor het ${write ? 'invullen' : 'lezen'} van het Groeidocument van ${student.firstname}`,
      reply_to_email: 'noreply@groeidocument.nl',
      sender_email: 'noreply@groeidocument.nl',
      sender_name: 'noreply@groeidocument.nl',
      body: templatedMailText || `Beste heer/mevrouw,<br><br>
      In deze mail vindt u de link waarmee u het Groeidocument van ${student.firstname} kunt ${write ? 'invullen' : 'lezen'}:<br>
      ${ticketbaseUrl}
      <br><br>

      ${(code && code.length > 0) ? 'De toegangscode hiervoor is in een afzonderlijke mail naar u verzonden.<br><br>' : ''}

      NB. Deze mail is veilig gegenereerd en verzonden vanuit Groeidocument.nl via noreply@groeidocument.nl. U kunt hierop niet antwoorden,
      uw mail komt niet aan. Mocht u uw contactpersoon willen benaderen, doe dit via het correcte e-mailadres.
      <br><br>

      Met vriendelijke groet,
      <br><br>
      ${student.gd_ibnaam}
      `
    }

    const codemail = {
      subject: templatedCodeMailTitle || 'Authenticatie voor toegang tot het Groeidocument van ' + student.firstname,
      reply_to_email: 'noreply@groeidocument.nl',
      sender_email: 'noreply@groeidocument.nl',
      sender_name: 'noreply@groeidocument.nl',
      body: templatedCodeMailText || `Beste heer/mevrouw,<br><br>
      Bij deze mail vindt u een code waarmee u toegang tot het Groeidocument krijgt. De link hiervoor bevindt zich in een andere mail.<br>
      De toegangscode voor dit Groeidocument is <b>${code}</b>.
      <br><br>

      NB. Deze mail is veilig gegenereerd en verzonden vanuit Groeidocument.nl via noreply@groeidocument.nl. U kunt hierop niet antwoorden,
      uw mail komt niet aan. Mocht u uw contactpersoon willen benaderen, doe dit via het correcte e-mailadres.
      <br><br>

      Met vriendelijke groet,
      <br><br>
      ${student.gd_ibnaam}
      `
    }

    await inviteTicket(mail, ticketHash)
    if (code && code.length > 0) {
      await inviteTicket(codemail, ticketHash)
    }
  }
}
